import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

/**
 * Backend: FolioItemType
 * - needs to be updated to match the same name
 */
export enum AccountItemTypeId {
  MANUAL_ITEM = 0,
  ACCOMMODATION = 1,
  ACCOMMODATION_NON_AUTOMATED = -1,
  GUEST_CATEGORY_DISCOUNT = 2,
  GUEST_CATEGORY_DISCOUNT_NON_AUTOMATED = -2,
  MEALS = 3,
  MEALS_NON_AUTOMATED = -3,
  RECREATION_TAX = 4,
  RECREATION_TAX_NON_AUTOMATED = -4,
  ACCOMMODATION_TAX = 5,
  ACCOMMODATION_TAX_NON_AUTOMATED = -5,
  SPECIAL_PRICE_DISCOUNT = 6,
  SPECIAL_PRICE_DISCOUNT_NON_AUTOMATED = -6,
  STOCK = 7,
  STOCK_NON_AUTOMATED = -7,
  STAY = 8,
  STAY_NON_AUTOMATED = -8,
  ACCOMMODATION_DISCOUNT = 9,
  ACCOMMODATION_DISCOUNT_NON_AUTOMATED = -9,
  MERGED_ACCOMMODATION = 10,
  MERGED_ACCOMMODATION_NON_AUTOMATED = -10,
  TERM_ACTION_DISCOUNT = 11,
  TERM_ACTION_DISCOUNT_NON_AUTOMATED = -11,
  ROUNDING = 12,
  ROUNDING_NON_AUTOMATED = -12,
  SERVICE = 13,
  SERVICE_NON_AUTOMATED = -13,
  OTHER_DISCOUNT_AND_EXTRA_CHARGE = 14,
  OTHER_DISCOUNT_AND_EXTRA_CHARGE_NON_AUTOMATED = -14,
  LAST_MINUTE_DISCOUNT = 15,
  LAST_MINUTE_DISCOUNT_NON_AUTOMATED = -15,
  FIRST_MINUTE_DISCOUNT = 16,
  FIRST_MINUTE_DISCOUNT_NON_AUTOMATED = -16,
  LONG_TERM_DISCOUNT = 17,
  LONG_TERM_DISCOUNT_NON_AUTOMATED = -17,
}

export class AccountItemType extends Codebook<AccountItemTypeId> {
  private constructor(
    public readonly id: AccountItemTypeId,
    public readonly name: () => string,
    public readonly icon: string,
    public readonly isAutomated: boolean,
    public readonly isIssued: boolean,
  ) {
    super(id)
  }

  static readonly MANUAL_ITEM = new AccountItemType(
    AccountItemTypeId.MANUAL_ITEM,
    () => $t('Manually added item'),
    'edit',
    false,
    false,
  )
  static readonly ACCOMMODATION = new AccountItemType(
    AccountItemTypeId.ACCOMMODATION,
    () => $t('Accommodation services'),
    'bed',
    true,
    true,
  )
  static readonly ACCOMMODATION_NON_AUTOMATED = new AccountItemType(
    AccountItemTypeId.ACCOMMODATION_NON_AUTOMATED,
    () => $t('Accommodation services'),
    'bed',
    false,
    true,
  )
  static readonly GUEST_CATEGORY_DISCOUNT = new AccountItemType(
    AccountItemTypeId.GUEST_CATEGORY_DISCOUNT,
    () => $t('Accommodation discount for guest category'),
    'percent',
    true,
    true,
  )
  static readonly GUEST_CATEGORY_DISCOUNT_NON_AUTOMATED = new AccountItemType(
    AccountItemTypeId.GUEST_CATEGORY_DISCOUNT_NON_AUTOMATED,
    () => $t('Accommodation discount for guest category'),
    'percent',
    false,
    true,
  )
  static readonly MEALS = new AccountItemType(
    AccountItemTypeId.MEALS,
    () => $t('Meals'),
    'utensils',
    true,
    true,
  )
  static readonly MEALS_NON_AUTOMATED = new AccountItemType(
    AccountItemTypeId.MEALS_NON_AUTOMATED,
    () => $t('Meals'),
    'utensils',
    false,
    true,
  )
  static readonly RECREATION_TAX = new AccountItemType(
    AccountItemTypeId.RECREATION_TAX,
    () => $t('City tax'),
    'coins',
    true,
    true,
  )
  static readonly RECREATION_TAX_NON_AUTOMATED = new AccountItemType(
    AccountItemTypeId.RECREATION_TAX_NON_AUTOMATED,
    () => $t('City tax'),
    'coins',
    false,
    true,
  )
  static readonly ACCOMMODATION_TAX = new AccountItemType(
    AccountItemTypeId.ACCOMMODATION_TAX,
    () => $t('Accommodation tax'),
    'coins',
    true,
    true,
  )
  static readonly ACCOMMODATION_TAX_NON_AUTOMATED = new AccountItemType(
    AccountItemTypeId.ACCOMMODATION_TAX_NON_AUTOMATED,
    () => $t('Accommodation tax'),
    'coins',
    false,
    true,
  )
  static readonly SPECIAL_PRICE_DISCOUNT = new AccountItemType(
    AccountItemTypeId.SPECIAL_PRICE_DISCOUNT,
    () => $t('Discount / surcharge - special price'),
    'percent',
    true,
    true,
  )
  static readonly SPECIAL_PRICE_DISCOUNT_NON_AUTOMATED = new AccountItemType(
    AccountItemTypeId.SPECIAL_PRICE_DISCOUNT_NON_AUTOMATED,
    () => $t('Discount / surcharge - special price'),
    'percent',
    false,
    true,
  )
  static readonly STOCK = new AccountItemType(
    AccountItemTypeId.STOCK,
    () => $t('Stock'),
    'boxes',
    true,
    false,
  )
  static readonly STOCK_NON_AUTOMATED = new AccountItemType(
    AccountItemTypeId.STOCK_NON_AUTOMATED,
    () => $t('Stock'),
    'boxes',
    false,
    false,
  )
  static readonly STAY = new AccountItemType(
    AccountItemTypeId.STAY,
    () => $t('Stay'),
    'hand-holding-box',
    true,
    true,
  )
  static readonly STAY_NON_AUTOMATED = new AccountItemType(
    AccountItemTypeId.STAY_NON_AUTOMATED,
    () => $t('Stay'),
    'hand-holding-box',
    false,
    true,
  )
  static readonly ACCOMMODATION_DISCOUNT = new AccountItemType(
    AccountItemTypeId.ACCOMMODATION_DISCOUNT,
    () => $t('Accommodation discount'),
    'percent',
    true,
    false,
  )
  static readonly ACCOMMODATION_DISCOUNT_NON_AUTOMATED = new AccountItemType(
    AccountItemTypeId.ACCOMMODATION_DISCOUNT_NON_AUTOMATED,
    () => $t('Accommodation discount'),
    'percent',
    false,
    false,
  )
  static readonly MERGED_ACCOMMODATION = new AccountItemType(
    AccountItemTypeId.MERGED_ACCOMMODATION,
    () => $t('Accommodation'),
    'bed',
    true,
    true,
  )
  static readonly MERGED_ACCOMMODATION_NON_AUTOMATED = new AccountItemType(
    AccountItemTypeId.MERGED_ACCOMMODATION_NON_AUTOMATED,
    () => $t('Accommodation'),
    'bed',
    false,
    true,
  )
  static readonly TERM_ACTION_DISCOUNT = new AccountItemType(
    AccountItemTypeId.TERM_ACTION_DISCOUNT,
    () => $t('Discount / surcharge - FM, LM, LT'),
    'percent',
    true,
    true,
  )
  static readonly TERM_ACTION_DISCOUNT_NON_AUTOMATED = new AccountItemType(
    AccountItemTypeId.TERM_ACTION_DISCOUNT_NON_AUTOMATED,
    () => $t('Discount / surcharge - FM, LM, LT'),
    'percent',
    false,
    true,
  )
  static readonly ROUNDING = new AccountItemType(
    AccountItemTypeId.ROUNDING,
    () => $t('Rounding'),
    'calculator',
    true,
    false,
  )
  static readonly ROUNDING_NON_AUTOMATED = new AccountItemType(
    AccountItemTypeId.ROUNDING_NON_AUTOMATED,
    () => $t('Rounding'),
    'calculator',
    false,
    false,
  )
  static readonly SERVICE = new AccountItemType(
    AccountItemTypeId.SERVICE,
    () => $t('Service'),
    'hand-holding-heart',
    true,
    true,
  )
  static readonly SERVICE_NON_AUTOMATED = new AccountItemType(
    AccountItemTypeId.SERVICE_NON_AUTOMATED,
    () => $t('Service'),
    'hand-holding-heart',
    false,
    true,
  )
  static readonly OTHER_DISCOUNT_AND_EXTRA_CHARGE = new AccountItemType(
    AccountItemTypeId.OTHER_DISCOUNT_AND_EXTRA_CHARGE,
    () => $t('Other discounts and surcharges'),
    'percent',
    true,
    false,
  )
  static readonly OTHER_DISCOUNT_AND_EXTRA_CHARGE_NON_AUTOMATED = new AccountItemType(
    AccountItemTypeId.OTHER_DISCOUNT_AND_EXTRA_CHARGE_NON_AUTOMATED,
    () => $t('Other discounts and surcharges'),
    'percent',
    false,
    false,
  )
  static readonly LAST_MINUTE_DISCOUNT = new AccountItemType(
    AccountItemTypeId.LAST_MINUTE_DISCOUNT,
    () => $t('Discount / surcharge - Last minute'),
    'percent',
    true,
    true,
  )
  static readonly LAST_MINUTE_DISCOUNT_NON_AUTOMATED = new AccountItemType(
    AccountItemTypeId.LAST_MINUTE_DISCOUNT_NON_AUTOMATED,
    () => $t('Discount / surcharge - Last minute'),
    'percent',
    false,
    true,
  )
  static readonly FIRST_MINUTE_DISCOUNT = new AccountItemType(
    AccountItemTypeId.FIRST_MINUTE_DISCOUNT,
    () => $t('Discount / surcharge - First minute'),
    'percent',
    true,
    true,
  )
  static readonly FIRST_MINUTE_DISCOUNT_NON_AUTOMATED = new AccountItemType(
    AccountItemTypeId.FIRST_MINUTE_DISCOUNT_NON_AUTOMATED,
    () => $t('Discount / surcharge - First minute'),
    'percent',
    false,
    true,
  )
  static readonly LONG_TERM_DISCOUNT = new AccountItemType(
    AccountItemTypeId.LONG_TERM_DISCOUNT,
    () => $t('Discount / surcharge - Long term'),
    'percent',
    true,
    true,
  )
  static readonly LONG_TERM_DISCOUNT_NON_AUTOMATED = new AccountItemType(
    AccountItemTypeId.LONG_TERM_DISCOUNT_NON_AUTOMATED,
    () => $t('Discount / surcharge - Long term'),
    'percent',
    false,
    true,
  )

  static get automated(): AccountItemType[] {
    return [
      AccountItemType.MANUAL_ITEM,
      AccountItemType.ACCOMMODATION,
      AccountItemType.GUEST_CATEGORY_DISCOUNT,
      AccountItemType.MEALS,
      AccountItemType.RECREATION_TAX,
      AccountItemType.ACCOMMODATION_TAX,
      AccountItemType.SPECIAL_PRICE_DISCOUNT,
      AccountItemType.STOCK,
      AccountItemType.STAY,
      AccountItemType.ACCOMMODATION_DISCOUNT,
      AccountItemType.MERGED_ACCOMMODATION,
      AccountItemType.TERM_ACTION_DISCOUNT,
      AccountItemType.ROUNDING,
      AccountItemType.SERVICE,
      AccountItemType.OTHER_DISCOUNT_AND_EXTRA_CHARGE,
    ]
  }

  static services(): AccountItemType[] {
    return [AccountItemType.SERVICE, AccountItemType.SERVICE_NON_AUTOMATED]
  }
}
